// Shared looks of the poster card's controls.

export const FOCUS =
	"focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"

/** A control over the art that is off: dark, so it reads on any poster. */
export const DARK =
	"bg-gray-950/85 text-gray-100 ring-1 ring-white/15 active:bg-gray-800"

/** A control in the desktop panel that is off. */
export const OFF =
	"bg-white/10 text-gray-100 hover:bg-white/20 active:bg-white/20"
